module.exports = __webpack_public_path__ + "img/20240802143902612H2.3efb6a3f.png";